import { useEffect } from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

// Shared page shell: fixed sidebar nav on desktop, top bar + bottom footer on
// mobile. Breakpoints are handled in CSS so nothing re-renders on resize.
function Layout({ title, children }) {
  useEffect(() => {
    document.title = title ? `${title} - Jonghwi Kim` : 'Jonghwi Kim'
  }, [title])

  return (
    <>
      <Navbar />
      <main className='px-6 sm:px-10 lg:pl-56 lg:pr-16 pt-10 lg:pt-12 pb-12'>
        <div className='max-w-5xl mx-auto lg:mx-0'>{children}</div>
      </main>
      <div className='lg:hidden'>
        <Footer />
      </div>
    </>
  )
}

export default Layout
